var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHardDrivesList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.0039H3.75C3.40482 12.0039 3.125 12.2837 3.125 12.6289V16.3789C3.125 16.7241 3.40482 17.0039 3.75 17.0039H16.25C16.5952 17.0039 16.875 16.7241 16.875 16.3789V12.6289C16.875 12.2837 16.5952 12.0039 16.25 12.0039Z",
    stroke: "#339EEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.50391H3.75C3.40482 4.50391 3.125 4.78373 3.125 5.12891V8.87891C3.125 9.22408 3.40482 9.50391 3.75 9.50391H16.25C16.5952 9.50391 16.875 9.22408 16.875 8.87891V5.12891C16.875 4.78373 16.5952 4.50391 16.25 4.50391Z",
    stroke: "#339EEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.94141C14.5803 7.94141 15 7.52167 15 7.00391C15 6.48614 14.5803 6.06641 14.0625 6.06641C13.5447 6.06641 13.125 6.48614 13.125 7.00391C13.125 7.52167 13.5447 7.94141 14.0625 7.94141Z",
    fill: "#677791"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 15.4414C14.5803 15.4414 15 15.0217 15 14.5039C15 13.9861 14.5803 13.5664 14.0625 13.5664C13.5447 13.5664 13.125 13.9861 13.125 14.5039C13.125 15.0217 13.5447 15.4414 14.0625 15.4414Z",
    fill: "#677791"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDrivesList);
export default __webpack_public_path__ + "static/media/HardDrivesList.771131e637e7bffe91e2e8280fa323bd.svg";
export { ForwardRef as ReactComponent };